import React from 'react';
import styled from 'styled-components';
import {
  CpBody03Secondary,
  CpHeading02Primary,
} from 'components/atoms/customer-portal/typography';
import { CpSectionWrapper } from '../../common';
import { CpHeroSectionVariantWidgetProps } from '../types';

const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 52px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 7rem;

  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: var(--cp-spacing-08);

  --cp-text-primary: var(--cp-white);
  --cp-text-secondary: var(--cp-white);

  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
  }

  /* 480px */
  @media (max-width: 30em) {
    padding-left: var(--cp-spacing-05);
    padding-right: var(--cp-spacing-05);
    align-items: center;
    justify-content: center;
  }
`;

const Title = styled(CpHeading02Primary)`
  margin-bottom: 0;
  margin-top: auto;
  text-align: left;
  width: 768px;
  max-width: 100%;

  /* tablet */
  @media (max-width: 768px) {
    width: 100%;
    padding-right: 0;
    text-align: center;
    margin-top: 0;
    width: 70%;
  }

  /* no padding in mobile */
  @media (max-width: 480px) {
    padding-right: 0;
    text-align: center;
    width: 90%;
  }
`;

const Description = styled(CpBody03Secondary)`
  text-align: left;
  width: 768px;

  /* tablet */
  @media (max-width: 768px) {
    width: 70%;
    padding-right: 0;
    text-align: center;
  }

  /* no padding in mobile */
  @media (max-width: 480px) {
    padding-right: 0;
    text-align: center;
    width: 90%;
  }
`;

export const CpHeroSectionFullBackground: React.FC<CpHeroSectionVariantWidgetProps> =
  ({ disabled, data, widget }) => {
    return (
      <CpSectionWrapper
        paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
        noVerticalPadding
        background={`url("${data?.heroSectionImage?.attachment?.location}")`}
        isBackgroundImage
        isDisabled={disabled}
        className="rl-cp-hero-section-full-background"
      >
        <Wrapper className="rl-cp-hero-section-fb-wrapper">
          <Title
            autoAdjustColor
            id="hero-title"
            data-cy="hero_section.full_bg_image.title"
          >
            {data.title}
          </Title>
          <Description
            data-cy="hero_section.full_bg_image.description"
            autoAdjustColor
          >
            {data.description}
          </Description>
        </Wrapper>
      </CpSectionWrapper>
    );
  };
